import { Route, Routes } from "react-router-dom"
import AddNewBase from "../base-system/pages/AddNewBase"
import BaseList from "../base-system/pages/BaseListing"
import EditBase from "../base-system/pages/EditBase"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<BaseList />} />
      <Route path="/create" element={<AddNewBase />} />
      <Route path="/edit/:id" element={<EditBase />} />
    </Routes>
  )
}
